<div class="mobile-filters-dialog"
    [ngClass]="{'mobile-filters-dialog--next': isNext}">

  <div *ngIf="isNext"
       class="dialog__close"
       (click)="close()"
       cdkFocusRegionstart>
    <span class="material-icons">close</span>
  </div>

  <div *ngIf="isNext"
       class="mobile-filters-dialog__data-summary">
    <app-insurance-data-summary></app-insurance-data-summary>
  </div>

  <div class="mobile-filters-dialog__filters">
    <app-offers-filters [embeddedInDialog]="true"></app-offers-filters>
  </div>
  <div *ngIf="!isNext"
       class="mobile-filters-dialog__button"
       (click)="applyFilters()">
    {{ 'OFFER_SECTION.FILTERS_COMPONENT.mobileDialogButtonText' | translate}}
  </div>

  <div *ngIf="isNext" class="mobile-filters-dialog__actions">
    <button (click)="clearFilters()"
            class="btn btn--clear-arrow">
      <span>{{ 'OFFER_SECTION.FILTERS_COMPONENT.clear' | translate }}</span>
      <span class="material-icons">arrow_right</span>
    </button>

    <button (click)="applyFilters()"
            class="btn btn--blue">
      {{ 'OFFER_SECTION.FILTERS_COMPONENT.mobileDialogButtonText' | translate }}
    </button>
  </div>
</div>
